import { render, staticRenderFns } from "./UpdateScreenshotButton.vue?vue&type=template&id=6812ed72&scoped=true&"
import script from "./UpdateScreenshotButton.vue?vue&type=script&lang=js&"
export * from "./UpdateScreenshotButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812ed72",
  null
  
)

component.options.__file = "UpdateScreenshotButton.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VBtn,
})
